<template>
  <div>
    <h2>目標一覧</h2>
    {{items}}
    <v-data-table
      :headers="headers"
      :items="items"
      hide-actions
      class="elevation-1"
      no-data-text="登録されてません。"
    >
      <template slot="items" slot-scope="props">
        <tr @click="toTarget(props.item.id)">
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td
            class="text-xs-left"
          >{{ getPeriod(props.item.set_start_date, props.item.set_end_date) }}</td>
          <td class="text-xs-left">{{ getPeriod(props.item.ok_start_date, props.item.ok_end_date)}}</td>
          <td
            class="text-xs-left"
          >{{ getPeriod(props.item.review_start_date, props.item.review_end_date) }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import db from "@/components/firebaseInit";
import { unixtimeToFormattedDate } from "@/utils/datetime.js";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  props: {},
  data() {
    return {
      dbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("challenge_sheets"),
      dbRefTargets: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("targets"),
      items: [],
      headers: [
        {
          text: "研修名",
          align: "left",
          sortable: false
        },
        {
          text: "設定期間",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "評価期間",
          align: "left",
          sortable: false
        },
        {
          text: "振り返り期間",
          align: "left",
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: 50
      }
    };
  },
  mounted() {
    this.reloadItems();
  },
  computed: {
    ...mapGetters("auth", ["user"])
  },
  methods: {
    async reloadItems() {
      this.changeLoadingState(true);
      this.items = [];
      ;
      // const items = await this.dbRef.where('user_id', "==", this.user.uid).get()
      const items = await this.dbRef.get();
      items.forEach(async doc => {
        const target = await this.dbRefTargets.doc(doc.data().target_id).get();

        if (target.exists) {
          this.items.push({ ...doc.data(), ...target.data(), id: doc.id });
        }
      });
      this.changeLoadingState(false);
    },
    getPeriod(start, end) {
      return (
        unixtimeToFormattedDate(start) + " ~ " + unixtimeToFormattedDate(end)
      );
    },
    toTarget(id) {
      this.$router.push({
        name: "target",
        params: { company_id: this.$route.params.company_id, sheet_id: id }
      });
    },
    ...mapActions("app", ["changeLoadingState"])
  }
};
</script>
<style lang="scss" scoped>
</style>